<div class="category-form">
    <h2>{{ categoryId ? 'Edit' : 'Add' }} Category </h2>

    <form [formGroup]="categoryForm" (ngSubmit)="onSubmit()">

        <div class="custom-form-group">
            <label class="custom-label" for="">Category Name
                <span class="star" style="display: inline-block !important;">*</span>
            </label>
            <div class="custom-form-control">
                <mat-form-field appearance="outline">
                    <input matInput placeholder="Category Name" formControlName="category_name">
                    <mat-error *ngIf="categoryForm.controls['category_name'].invalid && categoryForm.controls['category_name'].touched">
                        Category name is required
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="button-group" style="display: flex; justify-content: space-between; align-items: center;" fxLayoutAlign="end end" style="margin-top:auto;">
            <button mat-button type="button" color="warn" (click)="onCancel()">Cancel</button>

            <div fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="15px">
                <button type="submit" mat-button class="global-btn btn btn-sm">{{ categoryId ? 'Update' : 'Add' }}</button>
            </div>
        </div>

    </form>
</div>